import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';

import { InitService } from './services/utl/init.service';

import { ElementsComponent } from './components/elements/elements.component';



@NgModule({
  declarations: [
    ElementsComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    IonicModule
  ],
  entryComponents: [
    ElementsComponent
  ],
  exports: [
    ElementsComponent,
  ]
})
export class PayPalModule { 

  constructor(
    private init: InitService,
    // private alert: AlertService
  ){
    this.init.loadPayPal()
  }

}
